import styled from 'styled-components';

export const GridWrapper = styled.div`
    margin-top: ${({ theme }) => theme.spacing * 6}px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 24px;
    grid-gap: 24px;
    @media screen and (max-width: 690px) {
        grid-gap: 12px;
    }
    @media screen and (max-width: 320px) {
        grid-column-gap: 4px;
    }
`;

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 100px 40px;
`;
